import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Action, HTTPError } from '@mwe/models';
import { EnvironmentService } from '../environment/environment.service';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { ENVIRONMENT_SERVICE_TOKEN } from '@mwe/constants';

export interface LoggingServiceInterface {
  logError: (error: Error, message?: string) => Promise<void>;
  logAction: (action: Action) => Promise<void>;
}

@Injectable({ providedIn: 'root' })
export class LoggingService {
  private readonly http = inject(HttpClient);
  private readonly environmentService = inject<EnvironmentService>(ENVIRONMENT_SERVICE_TOKEN);

  resourceUrl: string;

  constructor() {
    this.resourceUrl = this.environmentService.getLoggingAPIOBaseURL() + 'api/log/';
  }

  async logError(error: Error, message?: string): Promise<void> {
    try {
      await lastValueFrom(
        this.http.post(this.resourceUrl + 'error', {
          message: `${message ? message + ': ' : ''}${this.errorMessage(error)}`,
          stack: error?.stack,
        }),
      );
    } catch (e) {
      console.error(`error on writing error log: ${e}`);
    }
  }

  private errorMessage(error: HTTPError | HttpErrorResponse | Error): string {
    if (error instanceof HTTPError) {
      return `${JSON.stringify(error.error)}`;
    }
    if (error instanceof HttpErrorResponse) {
      return `${JSON.stringify(error.error)}`;
    }
    if (error instanceof Error) {
      return error.message;
    }
    return 'Unrecognized Error object';
  }

  async logAction(action: Action): Promise<void> {
    try {
      // tslint:disable-next-line:no-console
      console.log(action);
      await firstValueFrom(this.http.post(this.resourceUrl + 'action', action));
    } catch (e) {
      console.error(`error on writing action log: ${e}`);
    }
  }
}
